import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const AdsContext = createContext({
  config: null,
  loading: true,
  refresh: () => {}
});

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AdsProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchConfig = async () => {
    try {
      const { data } = await axios.get(`${API}/settings/ads`);
      setConfig(data);
    } catch (e) {
      console.error('Failed to fetch ads config:', e);
      setConfig({ enabled: false, publisher_id: '', slot_top: '', slot_sidebar: '', slot_inline: '', slot_bottom: '' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  // Inject AdSense loader script once when publisher_id is set and ads are enabled
  useEffect(() => {
    if (!config || !config.enabled || !config.publisher_id) return;
    const scriptId = 'google-adsense-loader';
    if (document.getElementById(scriptId)) return;

    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${config.publisher_id}`;
    document.head.appendChild(script);
  }, [config]);

  return (
    <AdsContext.Provider value={{ config, loading, refresh: fetchConfig }}>
      {children}
    </AdsContext.Provider>
  );
}

export function useAdsConfig() {
  return useContext(AdsContext);
}
